// @ts-nocheck
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import constants from "@store/constants";
// import SideColumnLayoutComponent from "@store/Library/Components/Toolkit/Layout/SideColumnLayout"; // Store Custom Code
import React, { FC } from "react";

/* Store Custom Code - Start */
import SideColumnLayoutComponent from "@store/Library/Components/Toolkit/Layout/SideColumnLayout";
/* Store Custom Code - End */

const enum fields {
    showSideColumnOnMobile = "showSideColumnOnMobile",
    // Store Custom Code
    showSideColumnOnRight = "showSideColumnOnRight",
}

export interface SideColumnLayoutProps extends WidgetProps {
    fields: {
        [fields.showSideColumnOnMobile]?: boolean;
        // Store Custom Code
        [fields.showSideColumnOnRight]?: boolean;
    };
}

const SideColumnLayout: FC<SideColumnLayoutProps> = ({
    id,
    fields: {
        showSideColumnOnMobile,
        // Store Custom Code
        showSideColumnOnRight,
    },
}) => {
    return (
        <SideColumnLayoutComponent
            id={id}
            showSideColumnOnMobile={showSideColumnOnMobile}
            // Store Custom Code
            showSideColumnOnRight={showSideColumnOnRight}
        />
    );
};

const widgetModule: WidgetModule = {
    component: SideColumnLayout,
    definition: {
        group: constants.widgetGroup.layout,
        displayName: "Side Column Layout",
        icon: "table-layout",
        fieldDefinitions: [
            {
                name: fields.showSideColumnOnMobile,
                displayName: "Show side column content on mobile",
                editorTemplate: "CheckboxField",
                fieldType: "Contextual",
                defaultValue: false,
            },
            /* Store Custom Code - Start */
            {
                name: fields.showSideColumnOnRight,
                displayName: "Show side column on right",
                editorTemplate: "CheckboxField",
                fieldType: "Contextual",
                defaultValue: false,
            },
            /* Store Custom Code - End */
        ],
    },
};

export default widgetModule;
